var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopAppIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 455 408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "336.55 324.48 105.03 324.48 105.03 312.41 92.02 312.41 92.02 337.49 349.56 337.49 349.56 312.41 336.55 312.41 336.55 324.48",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.4,311.41h158.78v-23.89h132.27V7.5H9.13v280.02h132.27v23.89Zm145.77-13.01h-132.76v-10.88h132.76v10.88Zm-265.03-23.89V20.51h397.3v254H22.14Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.95 249.27 50.63 249.27 50.63 164.86 37.62 164.86 37.62 262.28 403.96 262.28 403.96 164.86 390.95 164.86 390.95 249.27",
    style: {
      fill: "#42c0b7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.62 143.04 50.63 143.04 50.63 45.75 390.95 45.75 390.95 143.04 403.96 143.04 403.96 32.74 37.62 32.74 37.62 143.04",
    style: {
      fill: "#42c0b7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.6 301.1 371.6 362.09 384.61 362.09 384.61 314.11 402.23 314.11 402.23 340.07 415.24 340.07 415.24 314.11 432.86 314.11 432.86 362.09 445.87 362.09 445.87 301.1 371.6 301.1",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m445.87,400.51h-74.27v-26.41h13.01v13.4h48.25v-13.4h13.01v26.41Z",
    style: {
      fill: "#d65e38"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopAppIcon);
export default __webpack_public_path__ + "static/media/desktop-app-icon.33cf96bd5ce190d854b56e148f0506af.svg";
export { ForwardRef as ReactComponent };